<script>
  import { onMount, onDestroy } from 'svelte';
  import settings from '../../config';
  import session from '../../lib/session';
  import {
    init_translations,
    init_debug_translations,
  } from '../../lib/translate.js';
  import { init_router } from '../guest-app/router.js';
  import APIClient from '../../state-charts/api-client';
  import WP from '../state-store.js';

  let language_init = false;
  // initializer functions --------------------------------------------------- //

  const set_translations = () => {
    // @ts-ignore:next-line
    let user_lang = navigator.language || navigator.userLanguage;
    let language = 'en';

    for (const lang of settings.supported_languages) {
      if (user_lang.includes(lang)) {
        language = lang;
      }
    }

    session.write({ user: { language: language } });

    init_translations(session);
  };

  const init_debug_vars = () => {
    // TODO: WP object kinyirando!
    WP.client = APIClient;
    WP.session = $session;
    WP.settings = settings;

    window.wp = WP;

    init_debug_translations();
  };

  // initialization ----------------------------------------------------------- //

  const init_app = async () => {
    await APIClient.get_config();
    init_router();

    // for debugging in development
    if ($session && window && settings.env !== 'production') {
      init_debug_vars();
    }
  };

  $: if((navigator.language || navigator.userLanguage) && !language_init){
    set_translations();
    language_init = true;
  }

  onMount(async () => { await init_app(); });
</script>



<style>

</style>